import { Component, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';

export interface DialogConfig {
    title?: string,
    content?: string,
    ok?: string,
    close: string
}

@Component({
    templateUrl: './dialog.component.html',
})
export class DialogComponent {

  get dialog(): DialogConfig {
      return this.data;
  }

  constructor(
      @Inject(MAT_DIALOG_DATA) public data: DialogConfig,
      public dialogRef: MatDialogRef<DialogComponent>
  ) {}

}
